export type BasicProfileData = {
	adId: string;
	profileType: ProfileType;
	address?: string;
	orgName: string;
	homepageUrl?: string;
	logo?: string;
	moreFromLink?: string;
	dsaAccepted?: boolean;
	companyRegistrationNumber?: string;
	phone: Phone[];
	contactUsUrl?: string;
	externalItemLink?: {
		text: string;
		uri: string;
	};
};

export type Phone = {
	phoneFormatted: string;
	phoneAsLink: string;
};

export enum ProfileType {
	None = 'none',
	Standard = 'standard',
	Fixed = 'fixed',
}
